import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {ModalComponent} from 'src/app/components/modal/modal.component';
import {ModalConfig} from 'src/app/components/modal/modal.config';
import {Farmaco, Response} from 'src/app/model/types';
import {ConfigService} from 'src/app/services/config/config.service';
import {ApiService} from '../../services/api/api.service';
import {farmaco} from 'src/app/services/api/api.mock';
import {BreadcrumbsService} from '../../services/breadcrumbs/breadcrumbs.service';

@Component({
  selector: 'app-details-page',
  templateUrl: './details-page.component.html',
  styleUrls: ['./details-page.component.scss'],
})
export class DetailsPageComponent implements OnInit {

  public breadcrumbLabelDetails = $localize`:details-page|breadcrumb-text-link@@details-page.breadcrumb-text:Dettagli`;
  public breadcrumbLabelResult = $localize`:result-page|breadcrumb-text-link@@result-page.breadcrumb-text:Risultati`;

  link = '';
  urlDownload: any;
  conf!: any;
  type!: string;

  farmaco$!: Observable<Response>;

  @ViewChild('modal') parallelImportModal!: ModalComponent;

  parallelImportModalConfig: ModalConfig = {
    modalTitle: 'Avviso: importazione parallela!',
    closeButtonLabel: 'Chiudi',
    centered: true,
    size: 'sm',
    hideCheckBox: () => true,
    hideDismissButton() {
      return true;
    },
  };

  constructor(
    private router: Router,
    private api: ApiService,
    private route: ActivatedRoute,
    private config: ConfigService,
    private breadcrumbService: BreadcrumbsService
  ) {
    this.conf = this.config.getConfig();
  }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    window.scrollTo(0, 0);
    if (id) {
      this.farmaco$ = this.api.getFarmacoDetails(id);
    }

    this.route.queryParams
      .subscribe(params => {

        // Otteniamo il percorso del link
        const urlTree = this.router.createUrlTree([], {relativeTo: this.route, queryParams: params});
        const url = this.router.serializeUrl(urlTree);

        // Aggiungo la url attuale all'array
        if(this.breadcrumbService.getLast()?.label=="Download")
        this.breadcrumbService.popUrl();
        this.breadcrumbService.pushUrl({label: this.breadcrumbLabelDetails, routerLink: url});
      });


  }


  getFile(farmaco: Farmaco, type: string) {
    if (farmaco.tipoAutorizzazione === 'P') {
      this.type = type;//definisce se il foglio è di tipo foglio illustrativo o riassunto caratteristiche prodotto
      this.parallelImportModal.open();
    } else {
      this.router.navigate([
        `/organizzazione/${farmaco.medicinale.codiceSis}/farmaci/${farmaco.medicinale.aic6}/stampati/${type}`,
      ]);
    }
  }


  getFileModal(codiceSis: number, aic6: number) {
    this.parallelImportModal.close();
    this.router.navigate([
      `/organizzazione/${codiceSis}/farmaci/${aic6}/stampati/${this.type}`,
    ]);
  }


}
